<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import { get } from "svelte/store"
	import LoadState from "../Enums/LoadState";

	import MapStore from "../Map/Store";

	export let notams = [];
	export let filterString = "";
	export let height = 300;

	let style = "height:"+height+"px;min-height:"+height+"px;";

	const dispatch = createEventDispatcher(); // update

	let isFilterMatch = (notam) => {
		let use = filterString.trim().toLowerCase();
		return (notam.country.toLowerCase().indexOf(use) >= 0 ||
				notam.id2.toLowerCase().indexOf(use) >= 0 ||
				(notam.qcode && notam.qcode.toLowerCase().indexOf(use) >= 0));
	};
</script>

<div class="maritime-boundaries-table-container mdc-elevation--z2" style={style}>
	<table class='svelte-table'>
		<thead>
			<tr>
				<th>Country</th>
				<th width="60">ID</th>
				<th width="45">QCode</th>
				<th width="70">Active?</th>
			</tr>
		</thead>
		<tbody>
			{#each notams as notam (notam.uniqId)}
				{#if filterString.trim().length === 0 || isFilterMatch(notam)}
					<tr>
						<td><a href="/" on:click|preventDefault={()=>{
							console.log("notam", notam);
							MapStore.helpers.zoomToFeature(notam.data);
						}}>{notam.country}</a></td>
						<td>{notam.id2}</td>
						<td>{#if notam.qcode}{notam.qcode}{:else}None{/if}</td>
						<td>{notam.activeStateState}</td>
					</tr>
				{/if}

			{/each}
		</tbody>
	</table>
</div>
